import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthFrame from "../auth/v2/AuthFrame";
import { TitleBlock, Actions, PrimaryBtn } from "../auth/v2/pieces";
import { landingPathFor } from "../auth/v2/landingPath";

// The catch-all route: an address no route matches. Signed in, it leads to
// the account's own home; signed out, to the login page.
const NotFound = () => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.user?.user?.permissions);
  const signedIn = !!localStorage.getItem("token");
  const target = signedIn ? landingPathFor(permissions) || "/" : "/login";

  return (
    <AuthFrame phoneLogo>
      <TitleBlock
        eyebrow="404"
        title="Page not found"
        sub="The link may be old or mistyped, or the page has moved."
      />
      <Actions>
        <PrimaryBtn onClick={() => navigate(target)}>{signedIn ? "Go to my home" : "Log in"}</PrimaryBtn>
      </Actions>
    </AuthFrame>
  );
};

export default NotFound;
